import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=50c0c056&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=50c0c056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c0c056",
  null
  
)

/* custom blocks */
import block0 from "@/common/i18n/i18n-locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fsean%2Fprojects%2Fezmeals%2Fezmeals-order-ui%2Fsrc%2Fpages%2Fmenu.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports